import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { Asset } from 'src/app/interfaces/asset';
import { ViewingService } from 'src/app/services/viewingService/viewing-service.service';

@Component({
  selector: 'app-viewing-list',
  templateUrl: './viewing-list.component.html',
  styleUrls: ['./viewing-list.component.less']
})
export class ViewingListComponent implements OnInit {
  assets: Asset[] = new Array();
  displayedColumns = ['select', 'position', 'date', 'title'];
  selection = new SelectionModel<any>(true, []);
  private isLoading = false;
  private offset = 0;
  private count = 50;
  constructor(private viewingService: ViewingService) { }

  ngOnInit(): void {
    this.assets = new Array();
    this.isLoading = false;
    this.offset = 0;
    this.getAssets();
  }

  // Get assets viewing history
  getAssets() {
    if (this.isLoading) {
      return;
    }
    let req = {
      offset: this.offset,
      count: this.count
    };
    this.isLoading = true;
    this.viewingService.getViewingHistory(req).then((resp: any) => {
      this.assets = this.assets && this.assets.length ? this.assets.concat(resp.data.viewingHistory) : resp.data.viewingHistory;
      this.isLoading = !resp.data.hasNext;
      this.offset += this.count;
    });
  }

  // On Scroll down
  onScroll() {
    this.getAssets();
  }

  // Delete Selected Items
  deleteItems() {
    let self = this;
    this.viewingService.removeViewingHistory(this.selection.selected.map(obj => obj.id)).then((resp: any) => {
      self.ngOnInit();
    });
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assets.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assets.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
}